<template>
  <div class="group block shrink-0" :class="[compact ? '' : 'p-4']">
    <div class="flex items-center overflow-x-hidden">
      <AuthAvatar v-if="showAvatar" :compact="compact" />
    </div>

    <AuthLogin :render-auth-login="RenderAuthLoginInstance" />
  </div>
</template>

<script setup lang="ts">
import { useLoginComposable } from '~/modules/auth/composables/useLoginComposable.js'

defineProps({
  compact: {
    type: Boolean,
    default: false,
  },
})

const showAvatar = computed(() => {
  return RenderAuthUserInstance?.value?.logged
})

const { RenderAuthLoginInstance, RenderAuthUserInstance } = useLoginComposable()
</script>
